var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slidefade"}},[(_vm.showModal && _vm.product.id)?_c('div',{staticClass:"modal"},[_c('ImportProductDetail',{attrs:{"product":_vm.product},on:{"addProduct":_vm.addProduct}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }